import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/19th_Century_-_Meiji_Restoration_Japan.png';
function HistoryPageMeijiRestorationGo() {
  return (
    <QuizPage
      title="History: Meiji Restoration"
      subTopic="Meiji Restoration (Japan)"
      backgroundImage={historyImage}
      returnPath="/History-Meiji-Restoration"
    />
  );
}

export default HistoryPageMeijiRestorationGo;
